import { CommonMainPage } from '../../widgets/utility/CommonMainPage'
import { BpTabs } from '../../shared/components/utility/tabs/BpTabs'
import { BpTab } from '../../shared/components/utility/tabs/tab/BpTab'
import { ScreenshotsReport } from './widgets/screenshots-report/ScreenshotsReport'
import { HTMLReport } from './widgets/html-report/HTMLReport'
import { LinksReport } from './widgets/links-report/LinksReport'
import { AdTable } from './widgets/ad-table/AdTable'
import { BlackhatMonitoringFilters } from './widgets/blackhat-monitoring-filters/BlackhatMonitoringFilters'
import { useAppDispatch, useAppSelector } from '../../app/store/hooks/Redux'
import {
  selectBlackhatMonitoringTab,
  setBlackhatMonitoringTab,
  TBlackhatMonitoringTabs,
} from './model/blackhatMonitoringSlice'
import { useTranslation } from 'react-i18next'
import { AiButton } from '../../shared/components/ai/ai-button/AiButton'
import React from 'react'
import { useAiChat } from '../../shared/components/ai/ai-provider/AiProvider'
import clsx from 'clsx'

import styles from './BlackhatMonitoringPage.module.scss'

export const BlackhatMonitoringPage = () => {
  const { t } = useTranslation()
  const { handleSendMessage } = useAiChat()
  const activeTab = useAppSelector(selectBlackhatMonitoringTab)
  const dispatch = useAppDispatch()

  const Panel = () => {
    return (
      <div className={clsx(styles.panel)}>
        {
          {
            bluepear: (
              <AiButton
                unstyled
                onClick={() =>
                  handleSendMessage({
                    message:
                      'Please provide a clear guide on how to use the Blackhat Monitoring (Uncloaking) tool and explain its value.',
                  })
                }
              >
                How it works
              </AiButton>
            ),
            robuscan: null,
            default: null,
          }[process.env.REACT_APP_PROJECT ?? 'default']
        }
      </div>
    )
  }

  return (
    <CommonMainPage
      hint={t('navigation.hint.blackhatMonitoring')}
      title={t('navigation.blackhatMonitoring')}
    >
      <BlackhatMonitoringFilters />
      <BpTabs
        active={activeTab}
        className={clsx(styles.tabs)}
        size={'md'}
        onToggle={(e) => dispatch(setBlackhatMonitoringTab(e as TBlackhatMonitoringTabs))}
      >
        <BpTab panel={<Panel />} title={t('pages.blackhatMonitoring.screenshots')}>
          <ScreenshotsReport />
        </BpTab>
        <BpTab panel={<Panel />} title={t('pages.blackhatMonitoring.HTML')}>
          <HTMLReport />
        </BpTab>
        <BpTab panel={<Panel />} title={t('pages.blackhatMonitoring.links')}>
          <LinksReport />
        </BpTab>
        <BpTab panel={<Panel />} title={t('pages.blackhatMonitoring.ad')}>
          <AdTable />
        </BpTab>
      </BpTabs>
    </CommonMainPage>
  )
}
